<template>
    <b-form class="form create-new-project">
        <b-form-textarea v-model="name" class="txtar" placeholder="New Project Name"></b-form-textarea>
        <b-button @click="setProjectName" variant="-primary">{{$t('files.base.add')}}</b-button>
    </b-form>
</template>

<script>
    export default {
        name: "NewProjectName",
        data() {
            return {
                name: null,
            }
        },
        methods: {
            setProjectName() {
                if (this.name) {
                    this.$emit('name', this.name)
                }
            }
        }
    }
</script>

<style lang="scss" scoped>
    .create-new-project {
        display: flex;
        width: 100%;

        .txtar {
            flex: 1;
            margin-right: 24px;
        }

        .btn {
            flex: 0;
        }
    }
</style>
